
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexoPPWrwi7VIMw5nNHX_45fuU6G2OFY1NjWlgGJlCrWQcpkMeta } from "/workspace/Optilink/web-portal-frontend/pages/index.vue?macro=true";
import { default as Loginzrp5_brssacUzxSSQHRRyPZ5BD4zPpnZ5NefsYW4h4IMeta } from "/workspace/Optilink/web-portal-frontend/pages/Login.vue?macro=true";
import { default as _91id_93uz_pKA_4597ewRQXghasBBEexfyjFjsTeDMyhNWbswUA8Meta } from "/workspace/Optilink/web-portal-frontend/pages/dashboards/[id].vue?macro=true";
import { default as indexTzLbEX_45k8_45A_45D_45aLC3vGevHOv_45eo0naGJrd0ckaFaY8Meta } from "/workspace/Optilink/web-portal-frontend/pages/dashboards/index.vue?macro=true";
import { default as _91id_93DG7E4uKiSBqHLx7MRG5AwMzfGg2P9TPJsVtUvcKONjUMeta } from "/workspace/Optilink/web-portal-frontend/pages/shared/[tokenId]/[id].vue?macro=true";
import { default as indexZvn7AU8VU7NHvTfBXVrg_45WXJ_45_45WVh7u95TTYXy8nynEMeta } from "/workspace/Optilink/web-portal-frontend/pages/[hexacode]/[department]/[subDepartment]/[page]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexoPPWrwi7VIMw5nNHX_45fuU6G2OFY1NjWlgGJlCrWQcpkMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/web-portal-frontend/pages/index.vue")
  },
  {
    name: "Login",
    path: "/Login",
    meta: { ...(Loginzrp5_brssacUzxSSQHRRyPZ5BD4zPpnZ5NefsYW4h4IMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/web-portal-frontend/pages/Login.vue")
  },
  {
    name: "dashboard",
    path: "/dashboards/:id()",
    meta: { ...(_91id_93uz_pKA_4597ewRQXghasBBEexfyjFjsTeDMyhNWbswUA8Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/web-portal-frontend/pages/dashboards/[id].vue")
  },
  {
    name: "dashboards",
    path: "/dashboards",
    meta: { ...(indexTzLbEX_45k8_45A_45D_45aLC3vGevHOv_45eo0naGJrd0ckaFaY8Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/web-portal-frontend/pages/dashboards/index.vue")
  },
  {
    name: "shared-dashboard",
    path: "/shared/:tokenId()/:id()",
    meta: _91id_93DG7E4uKiSBqHLx7MRG5AwMzfGg2P9TPJsVtUvcKONjUMeta || {},
    component: () => import("/workspace/Optilink/web-portal-frontend/pages/shared/[tokenId]/[id].vue")
  },
  {
    name: "department-page-view",
    path: "/:hexacode()/:department()/:subDepartment()/:page()",
    meta: { ...(indexZvn7AU8VU7NHvTfBXVrg_45WXJ_45_45WVh7u95TTYXy8nynEMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/web-portal-frontend/pages/[hexacode]/[department]/[subDepartment]/[page]/index.vue")
  }
]